
<span id="appVersion" class="hidden-information">{{version}}</span>
<span id="appEnvironment" class="hidden-information">{{environment}}</span>
<router-outlet/>
<!--<ng-progress></ng-progress>-->
<!--@if (loadingService.getLoading()|async) {-->
<!--  <app-global-loading></app-global-loading>-->
<!--}-->
